<div class="rp-install">
  <!-- Another install of a platform the project has: its name first. -->
  @if (naming()) {
  <form class="rp-install__naming" (ngSubmit)="confirmName()">
    <div class="rp-install__naming-head">
      <app-registration-platform-logo [name]="naming().name" [image]="naming().image"></app-registration-platform-logo>
      <div>
        <div class="rp-install__name">Add another {{ naming().name }}</div>
        <p class="rp-install__hint">This project already has {{ naming().installed === 1 ? 'one install' : naming().installed + ' installs' }} of {{ naming().name }}. Give the new one a name of its own.</p>
      </div>
    </div>
    <app-sb-input-text
      class="rp-install__name-field"
      label="Name"
      [required]="true"
      [error]="nameError()"
      [ngModel]="name"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onNameChange($event)">
    </app-sb-input-text>
    <div class="rp-install__naming-actions">
      <app-sb-button
        class="rp-install__back"
        variant="outline-secondary"
        size="sm"
        icon="fa fa-arrow-left"
        label="Back"
        [disabled]="installingId() !== null"
        (clicked)="back()">
      </app-sb-button>
      <app-sb-button
        class="rp-install__confirm"
        type="submit"
        variant="primary"
        size="sm"
        icon="fa fa-plus"
        label="Install"
        [ariaLabel]="'Install ' + naming().name"
        [loading]="installingId() === naming().id">
      </app-sb-button>
    </div>
  </form>
  } @else {
    <app-sb-input-text
      class="rp-install__search"
      label="Search platforms"
      [ngModel]="search"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSearch($event)">
    </app-sb-input-text>

    @if (loadError()) {
    <div class="alert alert-danger py-2" role="alert">{{ loadError() }}</div>
    }

    @if (loading() && !platforms().length) {
    <div class="rp-install__status">
      <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>Loading platforms…
    </div>
    }

    @if (platforms().length) {
    <div class="rp-install__grid" role="list" [attr.aria-busy]="loading()">
      @for (platform of platforms(); track trackById($index, platform)) {
      <div class="rp-install__card" role="listitem" [attr.data-platform-id]="platform.id">
        <app-registration-platform-logo [name]="platform.name" [image]="platform.image"></app-registration-platform-logo>
        <div class="rp-install__name">{{ platform.name }}</div>
        @if (platform.capabilities?.push || platform.installed) {
        <div class="rp-install__labels">
          @if (platform.capabilities?.push) {
          <span class="badge h-auto rp-install__capability">Push</span>
          }
          @if (platform.capabilities?.share_link_push) {
          <span class="badge h-auto rp-install__capability">Share link push</span>
          }
          @if (platform.installed) {
          <span class="badge text-bg-info h-auto rp-install__installed">{{ installedLabel(platform) }}</span>
          }
        </div>
        }
        <app-sb-button
          class="rp-install__action"
          variant="primary"
          size="sm"
          icon="fa fa-plus"
          [label]="platform.installed ? 'Install again' : 'Install'"
          [ariaLabel]="(platform.installed ? 'Install another ' : 'Install ') + platform.name"
          [loading]="installingId() === platform.id"
          [disabled]="installingId() !== null && installingId() !== platform.id"
          (clicked)="install(platform)">
        </app-sb-button>
      </div>
      }
    </div>
    }

    @if (!loading() && !loadError() && !platforms().length) {
    <p class="rp-install__status rp-install__empty">{{ emptyText }}</p>
    }
  }

</div>
